import { Button, Col, Form, Input, notification, Popconfirm, Row, Select, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { addIngredientUnitApi, listOfIngredientUnitApi, updateIngredientUnitApi } from "../../../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE, NUMBER_AND_FRACTIONAL_PATTERN, NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE } from "../../../../../config/constant";

export const IngredientsUnit = () => {
    const { Option } = Select;
    const [form] = Form.useForm();

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [IngredientUnitData, setIngredientUnitData] = useState()
    const [editIngredientUnitRecord, setEditIngredientUnitRecord] = useState()
    const [loading, setLoading] = useState(false)

    // get the list of all ingredient units 
    //==============================
    const getlistOfIngredientUnit = () => {
        setLoading(true)

        listOfIngredientUnitApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    //==============================
    const editIngredientUnit = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'name': data.name })
        form.setFieldsValue({ 'grams': data.gram })
        setEditIngredientUnitRecord(data);
    }

    useEffect(() => {
        getlistOfIngredientUnit()
    }, []);

    // filter data according to user search input 
    //==============================
    useEffect(() => {
        filterIngredientUnit(IngredientUnitData);
    }, [IngredientUnitData]);

    // filter recipe Ingredient Unit
    //==============================
    const filterIngredientUnit = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of recipe Ingredient Unit
    //==============================
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateIngredientUnitApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Ingredient Unit Update successfully",
                    });
                    getlistOfIngredientUnit()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Gram',
            dataIndex: 'gram',
            key: 'gram',
            render: (text) => <a>{text}</a>,
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.gram - b.gram,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editIngredientUnit(record) }} className="me-2" />
                    {/* <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}> */}
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];
    const data = [
        {
            id: '1',
            name: 'Teaspoon',
            status: true
        },
        {
            id: '2',
            name: 'Piece',
            status: false
        },
        {
            id: '3',
            name: 'Liters',
            status: true
        },
        {
            id: '4',
            name: 'Cup',
            status: true
        },
        {
            id: '5',
            name: 'Bowl',
            status: true
        },
    ];

    // handle submit
    //==============================
    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.name,
                "gram": values.grams,
                "status": true
            }
            addIngredientUnitApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'name': '' })
                        form.setFieldsValue({ 'grams': '' })
                        notification.success({
                            message: "Ingredient Unit added successfully",
                        });
                        getlistOfIngredientUnit()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.name,
                "gram": values.grams,
                "status": values.status
            }
            updateIngredientUnitApi(editIngredientUnitRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Ingredient Unit Update successfully",
                        });
                        getlistOfIngredientUnit()
                        form.setFieldsValue({ 'name': '' })
                        form.setFieldsValue({ 'grams': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="IngredientsUnit">
            <Row>
                <Col xl={14}>
                    <Form
                        name="IngredientsUnitForm"
                        className="IngredientsUnit"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="IngredientsUnitForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter name!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter name" className="p-2" />
                                </Form.Item>
                            </Col>

                            <Col xl={8} className="ms-1">
                                <Form.Item
                                    name="grams"
                                    rules={[
                                        {
                                            required: false,
                                            message: "Please Enter Grams!",
                                        },
                                        {
                                            pattern: NUMBER_AND_FRACTIONAL_PATTERN,
                                            message: NUMBER_AND_FRACTIONAL_PATTERN_MESSAGE,
                                        },
                                    ]}
                                >
                                    <Input placeholder="Enter Grams" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={7}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2"
                                    icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />} >
                                    {buttonName}
                                </Button>
                            </Col>

                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    {/* <h6>{tagCategory ?  `Total ${tagCategory}` : "Total Tags"  }</h6> */}
                    <h6> Total Ingredient Unit : {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Category"
                        onChange={(e) => { filterIngredientUnit(e.target.value); setIngredientUnitData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
